import {
  customShadowlessElement,
  CorrectComponentType,
  correctElementType,
} from '@brytdesigns/web-component-core/utils';

type Props = {};

const Name = 'featured-collection-tabs';

const Component: CorrectComponentType<Props> = (_props, { element }) => {
  const tabs = Array.from(element.querySelectorAll<HTMLButtonElement>('[role="tab"]'));
  const panels = Array.from(element.querySelectorAll<HTMLElement>('[role="tabpanel"]'));
  if (!tabs.length) return;

  const activate = (idx: number) => {
    tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', i === idx ? 'true' : 'false');
    });
    panels.forEach((panel, i) => {
      if (i === idx) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
  };

  tabs.forEach((tab, idx) => {
    tab.addEventListener('click', () => activate(idx));
  });
};

customShadowlessElement(Name, {}, correctElementType(Component));
